module.exports = __webpack_public_path__ + "img/政策与制度_04.21ff419f.jpg";